import useIsGiftCardPreviewRoute from '../../giftCards/hooks/useIsGiftCardPreviewRoute'
import { AppRoutes } from '../constants'

import useRouteMatch from './useRouteMatch'

const NonOrderRoutes = [
  AppRoutes.Auth,
  AppRoutes.PreOrderLink,
  AppRoutes.GroupOrder,
]

/**
 * Checks if the current route is related to order process.
 * Following routes are considered as non-order routes:
 * - Auth
 * - PreOrderLink
 * - GroupOrder
 * - GiftCardPreview
 */
export default function useIsOrderRoute() {
  const isNonOrderRoute = useRouteMatch(NonOrderRoutes)

  const isGiftCardPreviewRoute = useIsGiftCardPreviewRoute()

  const isOrderRoute = !isNonOrderRoute && !isGiftCardPreviewRoute

  return isOrderRoute
}
